/**
* Image Content Card Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Content Card Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'image-content-card-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.image-content-card-slider' ).each( function() {
        $( this ).find( '.slider' ).slick( {
          dots: false,
          arrows: true,
          infinite: false,
          prevArrow: $( this ).closest( '.image-content-card-slider' ).find( '.slider-nav--desktop .slider-prev' )[0],
          nextArrow: $( this ).closest( '.image-content-card-slider' ).find( '.slider-nav--desktop .slider-next' )[0],
          slidesToShow: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                prevArrow: $( this ).closest( '.image-content-card-slider' ).find( '.slider-nav--mobile .slider-prev' )[0],
                nextArrow: $( this ).closest( '.image-content-card-slider' ).find( '.slider-nav--mobile .slider-next' )[0],
              },
            },
          ],
        } );

        $( this ).find( '.slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
          const newImage = $( this ).closest( '.image-content-card-slider' ).find( '.image-wrapper .slide-image[data-slide="' + nextSlide + '"]' );
          $( this ).closest( '.image-content-card-slider' ).find( '.image-wrapper .slide-image' ).not( newImage ).removeClass( 'is-active' );
          $( newImage ).addClass( 'is-active' );
        } );

        const imageHeight = $( this ).find( '.image-wrapper' ).outerHeight();
        $( this ).find( '.slide' ).css( 'min-height', imageHeight );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-content-card-slider', COMPONENT );
} )( app );
